import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import Media from '@components/atoms/Media';
import Link from '@components/atoms/Link';
import HeaderFont from '@components/atoms/HeaderFont';
import { FiCheck } from '@react-icons/all-files/fi/FiCheck';
import { dataLayerStockistClick } from '@helpers/dataLayerPush';

const WhereToBuyCard = ({ whereToBuyCards }) => {
  return (
    <>
      {whereToBuyCards.map((item, i) => (
        <Box
          key={`whereToBuyCards${i + 1}`}
          boxShadow="md"
          rounded="md"
          bg="white">
          <Flex flexDirection="column" height="100%">
            <Box pt="8" px="6" pb="6">
              <Flex justifyContent="flex-start" alignItems="center">
                <Box pr="8" maxW="32">
                  <Media
                    width="auto"
                    objectFit="cover"
                    display="inline-flex"
                    media={item.logo}
                  />
                </Box>
                <Box>
                  <HeaderFont
                    fontWeight="900"
                    fontStyle="italic"
                    color="purple.600"
                    fontSize="xl"
                    pb="2">
                    {item.name}
                  </HeaderFont>
                  <Link
                    variant="ghostButton"
                    href={item.ctaLink}
                    w="auto"
                    textAlign="center"
                    onClick={() => {
                      dataLayerStockistClick({
                        event: `find_store`
                      });
                    }}
                    target="_blank">
                    <HeaderFont fontWeight="700" textTransform="uppercase">
                      {item.ctaText}
                    </HeaderFont>
                  </Link>
                </Box>
              </Flex>
            </Box>
            {item.infoText && item.infoText.length > 0 && (
              <Flex
                bg="gray.100"
                p="4"
                mt="auto"
                borderBottomRightRadius="0.375rem"
                borderBottomLeftRadius="0.375rem"
                justifyContent="center"
                fontSize="xs"
                alignItems="center">
                <FiCheck color="#7D55C7" size={15} />
                <Box ml="1">{item.infoText}</Box>
              </Flex>
            )}
          </Flex>
        </Box>
      ))}
    </>
  );
};

export default WhereToBuyCard;
